export const FAMILY_MEMBERS = "/api/folder/:param/family-information/members"
export const FAMILY_MEMBER = "/api/folder/:param/family-information/member/:familyMemberParam"
